<div class="inner-content">
  <div class="inner-div">
    <div class="d-flex flex-row">
      <button id='close' (click)="closeModal()">close</button>
    </div>
  </div>
  <div class="inner-div">
    <span class="span-title">{{
      hasQuantityCampaign()
      ? 'Detalhes da campanha'
      : bonusData && bonusData.length > 0
      ? 'Produtos de oferta'
      : 'Detalhes da campanha'
      }}
    </span>
    @if (bonusData && bonusData.length > 0) {
      <div class="inside-content2">
        @for (product of bonusData; track product; let i = $index) {
          <div>
            <div class="product-bonus">
              @if (!product.imageURL.endsWith('product_placeholder.png')) {
                <div>
                  <img [src]="product.imageURL" [alt]="product.referenceBonus">
                </div>
              }
              @if (product.imageURL.endsWith('product_placeholder.png')) {
                <div class="placeholderDiv">
                  <img [src]="product.imageURL" [alt]="product.referenceBonus">
                  <span>Imagem não disponibilizada</span>
                </div>
              }
              <div class="text-center">
                <span>{{ product.bonuses[0].description }}</span>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-end">
              @for (bonus of product.bonuses; track bonus) {
                <div class="plus-bonus">
                  <span>{{ bonus.bonus }}</span>
                  @if (shouldShowAddButton) {
                    <div class="plus-btn" (click)="callCrudCart(passedData, bonus.bonus)">+</div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (data.bonusData.quantityCampaign?.length) {
      @for (campaign of data.bonusData.quantityCampaign; track campaign; let i = $index) {
        @if (campaign.quantity >= 0 && campaign.discountPercentage > 0) {
          <div class="col-md-12 col-xs-12 text-center mobileAdjust1 quantityCampaignSection"
            [ngStyle]="{'margin-top': i === 0 ? '20px' : '10px'}">
            @if (i === (data.bonusData.quantityCampaign?.length || 0) - 1) {
              Na compra de {{ campaign.quantity + 1 }} ou mais unidades, o artigo tem um desconto de {{
              campaign.discountPercentage }}%.
            }
            @if (data.bonusData.quantityCampaign && i < data.bonusData.quantityCampaign.length - 1) {
              Na compra de {{ campaign.quantity + 1 }} a {{ data.bonusData.quantityCampaign[i + 1].quantity || 0 }}
              unidades, o artigo tem um desconto de {{ campaign.discountPercentage }}%.
            }
          </div>
        }
      }
    }
  </div>